<div class="page-container">
  <div class="header-section">
    <h1>Article Types</h1>
    <button class="btn-primary" (click)="createArticleType()">
      <span class="material-icons">add</span>
      New Article Type
    </button>
  </div>

  <div class="filter-section">
    <div class="search-box">
      <span class="material-icons search-icon">search</span>
      <input pInputText [(ngModel)]="searchText" (input)="onSearchChange()"
        placeholder="Search by English or German name..." class="search-input" />
      <button *ngIf="searchText" class="clear-search-btn" (click)="clearSearch()">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="filter-info">
      <span class="result-count">{{ gridView.total }} Article Types found</span>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner styleClass="labtech-spinner" ariaLabel="Loading"></p-progressSpinner>
    <p>Loading article types...</p>
  </div>

  <div class="cards-grid" *ngIf="!loading">
    <div class="card" *ngFor="let articleType of gridView.data" [@cardAnimation]>

      <div class="card-image-header">
        <img *ngIf="articleType.imageUrl" [src]="articleType.imageUrl" alt="{{ articleType.english }}"
          class="card-image" (error)="onImageError($event)" />
        <div *ngIf="!articleType.imageUrl" class="card-image-placeholder">
          <span class="material-icons placeholder-icon">image</span>
          <span class="placeholder-text">No Image</span>
        </div>
      </div>

      <div class="card-header">
        <div class="card-icon">
          <span class="material-icons">category</span>
        </div>
        <div class="card-title-section">
          <h3 class="card-title">{{ articleType.english || 'Unnamed' }}</h3>
        </div>
        <div class="overview-card-actions">
          <button type="button" class="card-icon-btn" (click)="toggleActionMenu(articleType.databaseId, $event)"
            [attr.aria-expanded]="isActionMenuOpen(articleType.databaseId)" title="Article type actions">
            <span class="material-icons">more_vert</span>
          </button>
          <div class="card-action-menu" *ngIf="isActionMenuOpen(articleType.databaseId)" (click)="$event.stopPropagation()">
            <button type="button" class="menu-action" (click)="closeActionMenu(); editArticleType(articleType)">
              <span class="material-icons">edit</span>
              Edit
            </button>
            <button *ngIf="articleType.canBeDeleted" type="button" class="menu-action menu-action-danger"
              (click)="closeActionMenu(); deleteArticleType(articleType)">
              <span class="material-icons">delete</span>
              Delete
            </button>
            <button *ngIf="!articleType.canBeDeleted" type="button" class="menu-action menu-action-disabled" disabled>
              <span class="material-icons">info</span>
              Used in Inspection
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="info-row">
          <span class="material-icons info-icon">translate</span>
          <div class="info-content">
            <span class="info-label">English Name</span>
            <span class="info-value">{{ articleType.english || 'N/A' }}</span>
          </div>
        </div>

        <div class="info-row">
          <span class="material-icons info-icon">language</span>
          <div class="info-content">
            <span class="info-label">German Name</span>
            <span class="info-value">{{ articleType.german || 'N/A' }}</span>
          </div>
        </div>

        <div class="info-row">
          <span class="material-icons info-icon">collections</span>
          <div class="info-content">
            <span class="info-label">Images</span>
            <span class="info-value">{{ articleType.images?.length || 0 }} image(s)</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <app-empty-state
    *ngIf="!loading && gridView.data.length === 0"
    icon="search_off"
    headline="No article types found"
    [subline]="searchText ? 'Try adjusting your search criteria' : 'Click &quot;New Article Type&quot; to create your first article type'">
  </app-empty-state>

  <div class="pagination-section" *ngIf="!loading && gridView.total > 0">
    <p-paginator [totalRecords]="gridView.total" [rows]="state.take ?? 12" [first]="state.skip ?? 0" [rowsPerPageOptions]="[12, 24, 48]" (onPageChange)="pageChange($event)"></p-paginator>
    <span class="result-count pagination-range">{{ footerRangeLabel }}</span>
  </div>

  <ng-container *ngIf="deleteDialog">
    <p-dialog [modal]="true" [visible]="true" header="Delete User" (onHide)="toggleDeleteDialog()" [style]="{ width: '450px' }">
      <div class="dialog-content">
        <p>Are you sure you want to delete Article Type <strong>{{ selectedArticleType?.english }}</strong>?</p>
        <p class="dialog-warning-text">This action cannot be undone.</p>
      </div>
      <ng-template pTemplate="footer">
        <button class="btn-secondary" (click)="toggleDeleteDialog()">Cancel</button>
        <button class="btn-primary" (click)="confirmDelete()">
          <span class="material-icons">delete</span>
          Delete
        </button>
      </ng-template>
    </p-dialog>
  </ng-container>
